/*函数防抖*/
export const debounce = (fn, interval) => {
  var timer;
  var gapTime = interval || 300; //间隔时间，如果interval不传，则默认1000ms
  return function() {
    clearTimeout(timer);
    var context = this;
    var args = arguments; //保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function() {
      fn.apply(context, args);
    }, gapTime);
  };
};

/*函数节流*/
export const throttle = (fn, interval) => {
  var enterTime = 0; //触发的时间
  var gapTime = interval || 300; //间隔时间，如果interval不传，则默认300ms
  return function() {
    var context = this;
    var backTime = new Date(); //第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.apply(context, arguments);
      enterTime = backTime; //赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
};

export const banList = (data) => {
  if (window.displayList !== undefined && !window.displayList) return false
  const keys = Object.keys(data)
  // 是否有搜索的参数
  let flag = false
  for (let key of keys) {
    if (['limit', 'per_page', 'page', 'created_from',
    'created_to', 'start_at', 'end_at', 'export', 'token',
    'append_type', 'is_channel', 'is_game', 'is_package', 'rechannel', 'table_type', 'total'].includes(key)) continue
    if (data[key] instanceof Array) {
      if (data[key].length) {
        flag = true
        break
      }
    } else if (data[key]) {
      flag = true
      break
    }
  } 
  return !flag
}

// 公共方法 url
export const urlSplicing = (url, data) => {
  if (!banList(data) && !window.canExport) {
    let str = "";
    for (let key in data) {
      str = str + key + "=" + data[key] + "&";
    }
    url = url + "?" + str;
    window.open(url);
  }
};

export const getValue = (obj, key) => {
  const keyList = key.split('.')
  if (!obj) return '-'
  if (keyList.length === 1) return obj[key]
  let value = '-'
  for (let i = 0; i < keyList.length; i++) {
    const keyItem = keyList[i]
    if (i === 0) {
      const item = obj[keyItem]
      if (!item) return '-'
      value = item
    } else {
      value = value[keyItem]
    }
  }
  return value
};
